module.exports = __webpack_public_path__ + "img/presention-chart.a00c2255.svg";